import React from "react";

const People = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_559_1382)">
        <path
          d="M9.3568 5.70184H8.31528C8.17353 5.70184 8.03629 5.72121 7.90568 5.75683C7.64804 5.25035 7.12202 4.90234 6.5159 4.90234H4.67489C4.06876 4.90234 3.54274 5.25035 3.2851 5.75683C3.15449 5.72121 3.01725 5.70184 2.8755 5.70184H1.83398C0.974576 5.70184 0.275391 6.40103 0.275391 7.26043V8.92539C0.275391 9.44103 0.694902 9.86054 1.21055 9.86054H9.98024C10.4959 9.86054 10.9154 9.44103 10.9154 8.92539V7.26043C10.9154 6.40103 10.2162 5.70184 9.3568 5.70184ZM3.11629 6.46098V9.23713H1.21055C1.03867 9.23713 0.898828 9.09729 0.898828 8.92541V7.26046C0.898828 6.74481 1.31834 6.3253 1.83398 6.3253H2.8755C2.96012 6.3253 3.04206 6.33679 3.12007 6.35797C3.11783 6.39207 3.11629 6.42636 3.11629 6.46098ZM7.45105 9.23713H3.73973V6.46096C3.73973 5.94531 4.15924 5.5258 4.67489 5.5258H6.5159C7.03154 5.5258 7.45105 5.94531 7.45105 6.46096V9.23713ZM10.292 8.92541C10.292 9.09729 10.1521 9.23713 9.98024 9.23713H8.07449V6.46096C8.07449 6.42632 8.07295 6.39203 8.07071 6.35795C8.14872 6.33679 8.23066 6.32528 8.31528 6.32528H9.3568C9.87244 6.32528 10.292 6.74479 10.292 7.26043V8.92541Z"
          fill="white"
        />
        <path
          d="M2.35471 2.75586C1.59102 2.75586 0.969727 3.37716 0.969727 4.14085C0.969706 4.90454 1.59102 5.52583 2.35471 5.52583C3.11838 5.52583 3.7397 4.90454 3.7397 4.14085C3.7397 3.37716 3.1184 2.75586 2.35471 2.75586ZM2.35469 4.9024C1.93477 4.9024 1.59314 4.56077 1.59314 4.14085C1.59314 3.72092 1.93477 3.3793 2.35469 3.3793C2.77462 3.3793 3.11624 3.72092 3.11624 4.14085C3.11624 4.56077 2.77462 4.9024 2.35469 4.9024Z"
          fill="white"
        />
        <path
          d="M5.59544 1.03613C4.57516 1.03613 3.74512 1.86618 3.74512 2.88645C3.74512 3.90673 4.57516 4.73677 5.59544 4.73677C6.61571 4.73677 7.44576 3.90673 7.44576 2.88645C7.44576 1.8662 6.61571 1.03613 5.59544 1.03613ZM5.59544 4.11334C4.91893 4.11334 4.36855 3.56297 4.36855 2.88645C4.36855 2.20996 4.91893 1.65957 5.59544 1.65957C6.27195 1.65957 6.82232 2.20994 6.82232 2.88645C6.82232 3.56297 6.27195 4.11334 5.59544 4.11334Z"
          fill="white"
        />
        <path
          d="M8.83616 2.75586C8.07249 2.75586 7.45117 3.37716 7.45117 4.14085C7.45119 4.90454 8.07249 5.52583 8.83616 5.52583C9.59985 5.52583 10.2211 4.90454 10.2211 4.14085C10.2211 3.37716 9.59985 2.75586 8.83616 2.75586ZM8.83616 4.9024C8.41625 4.9024 8.07461 4.56077 8.07461 4.14085C8.07463 3.72092 8.41625 3.3793 8.83616 3.3793C9.25609 3.3793 9.59771 3.72092 9.59771 4.14085C9.59771 4.56077 9.25609 4.9024 8.83616 4.9024Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_559_1382">
          <rect
            width="10.64"
            height="10.64"
            fill="white"
            transform="translate(0.275391 0.128418)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default People;
